<template>
  <el-dialog
    title="批量上/下架"
    :visible.sync="dialogVisible"
    width="640px"
    @close="closeDialog"
  >
    <el-form label-width="180px">
      <el-form-item label="选择商品分组">
        <div class="category-select-box">
          <el-checkbox v-model="form.selectAll" @change="onSelectAllChange">全部</el-checkbox>
          <el-checkbox-group
            v-model="form.selectedCategoryIds"
            :disabled="form.selectAll"
            @change="onCategoryChange"
          >
            <div
              v-for="category in form.categories"
              :key="category.categoryId"
              class="category-item"
              :class="{ 'category-child': category.categoryLevel == '2' }"
            >
              <el-checkbox :label="category.categoryId">
                {{ category.categoryName }}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </el-form-item>
      <el-form-item label="同步时商品自动上下架">
        <el-radio-group v-model="form.syncAutoShelfOn">
          <el-radio :label="true">开启</el-radio>
          <el-radio :label="false">关闭</el-radio>
        </el-radio-group>
        <div class="form-tip">
          开启后允许第三方同步库存时根据库存自动修改上下架；关闭后将锁定上下架状态，同步时不再自动修改上下架。
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="warning" :loading="submitting" @click="submitBatchUpdate('1001')">批量下架</el-button>
      <el-button type="primary" :loading="submitting" @click="submitBatchUpdate('2002')">批量上架</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { batchUpdateProductState } from '@/api/goods/productApi'

export default {
  name: 'BatchUpdateProductState',
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      form: {
        shopId: '',
        categories: [],
        selectedCategoryIds: [],
        selectAll: false,
        syncAutoShelfOn: true
      }
    }
  },
  methods: {
    open(params) {
      this.form = {
        shopId: params.shopId || '',
        categories: params.productCategorys || [],
        selectedCategoryIds: [],
        selectAll: false,
        syncAutoShelfOn: true
      }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    onSelectAllChange(checked) {
      if (checked) {
        this.form.selectedCategoryIds = []
      }
    },
    onCategoryChange() {
      if (this.form.selectedCategoryIds.length > 0) {
        this.form.selectAll = false
      }
    },
    collectCategoryIds() {
      if (this.form.selectAll) {
        return {
          updateAll: 'Y',
          categoryIds: []
        }
      }
      const ids = (this.form.selectedCategoryIds || []).slice()
      const categories = this.form.categories || []
      categories.forEach(category => {
        if (ids.indexOf(category.categoryId) >= 0) {
          categories.forEach(child => {
            if (child.parentCategoryId === category.categoryId && ids.indexOf(child.categoryId) < 0) {
              ids.push(child.categoryId)
            }
          })
        }
      })
      return {
        updateAll: 'N',
        categoryIds: ids
      }
    },
    async submitBatchUpdate(state) {
      const categoryInfo = this.collectCategoryIds()
      if (categoryInfo.updateAll !== 'Y' && (!categoryInfo.categoryIds || categoryInfo.categoryIds.length < 1)) {
        this.$message.warning('请选择商品分组或勾选全部')
        return
      }
      const actionText = state === '2002' ? '批量上架' : '批量下架'
      this.submitting = true
      try {
        const res = await batchUpdateProductState({
          shopId: this.form.shopId,
          state,
          updateAll: categoryInfo.updateAll,
          categoryIds: categoryInfo.categoryIds,
          syncAutoShelfOn: !!this.form.syncAutoShelfOn
        })
        if (res.code === 0) {
          this.$message.success(res.msg || `${actionText}成功`)
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg || `${actionText}失败`)
        }
      } catch (error) {
        console.error(`${actionText}失败:`, error)
        this.$message.error(`${actionText}失败`)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.category-select-box {
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 12px;
}

.category-item {
  margin-bottom: 6px;
}

.category-child {
  padding-left: 16px;
}

.form-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
